import React from "react";
import HeroImage from "../../assets/Images/LoginPage-Hero.png";
import { login } from "../../services/CommonService";
import ClientLogo from "../../components/ClientLogo/ClientLogo";
import sprylogo from "../../assets/Images/spry-logo.svg";
import { useForm } from "react-hook-form";
import { Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth";
import { useOrgContext } from "../../Context/orgContext";

const Login = () => {
  const { register, handleSubmit } = useForm();
  const navigate = useNavigate();
  const { setIsLogedOut } = useOrgContext();
  const auth = useAuth();
  const location = useLocation();
  const redirectPath = location.state?.path || "/"; 
  const onSubmit = (data) => {
    const userInfo = `${data.email}:${data.password}`;
    const encodedData = btoa(userInfo);
    login(encodedData).then((res) => {
      if (res.jwt) {
        setIsLogedOut(false);
        auth.login("LoggedIn");
        navigate(redirectPath, { replace: true });
      }
    });
  };

  return (
    <div className="flex">
      <div className="w-1/2">
        <img src={HeroImage} className="h-screen" alt="" />
      </div>
      <div className="w-1/2">
        <div className="flex justify-end pr-6 pt-6">
          <ClientLogo />
        </div>
        <div className="flex items-center" style={{
          height: "calc(100vh - 140px)",
        }}>
        <div className="w-[360px] ml-[70px]">
          <div className="text-[#101828] font-semibold text-3xl leading-[44px] mb-3">
            Log in
          </div>
          <div className="text-[#475467] text-base leading-6 font-normal mb-8">
            Welcome back! Please enter your details.
          </div>
          <form>
            <div className="pb-3 flex justify-between flex-col">
              <label
                htmlFor="email"
                className="text-[#344054] text-sm leading-5 font-medium mb-[6px]"
              >
                Username
              </label>
              <input
                {...register("email", { required: true })}
                type="text"
                className="rounded-lg border-[1px] border-[#D0D5DD] pt-[14px] pb-[14px] pl-[24px] mb-5"
              />
              <label
                htmlFor="password"
                className="text-[#344054] text-sm leading-5 font-medium mb-[6px]"
              >
                Password
              </label>
              <input
                onChange={(e) => {
                  console.log(e);
                }}
                {...register("password")}
                type="password"
                className="rounded-lg border-[1px] border-[#D0D5DD] pt-[14px] pb-[14px] pl-[24px] mb-6"
              />
              <Button
                onClick={handleSubmit(onSubmit)}
                sx={{
                  backgroundColor: "#212225",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  borderRadius: "5px",
                  color: "#fff",
                  ":hover": {
                    backgroundColor: "#212225",
                    color: "#fff",
                  },
                }}
              >
                Sign in
              </Button>
            </div>
          </form>
        </div>
        </div>
        <div
          className="absolute bottom-0"
          style={{
            width: "inherit",
          }}
        >
          <div className="flex justify-end mr-7 mt-6 mb-7">
            <div className="flex justify-end items-center z-10">
              <span
                className="italic"
                style={{
                  marginRight: "0.438rem",
                }}
              >
                Powered by
              </span>
              <img
                style={{
                  width: "2.563rem",
                  height: "0.938rem",
                }}
                src={sprylogo}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
